import { useEffect, useState } from 'react';

/**
 * Tracks vertical scroll. Returns whether the page has scrolled past
 * the supplied threshold (default 120px). Used by the header to switch into
 * its compact "eyebrow" state.
 */
export const useScrollHeader = (threshold = 120) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
};